<template>
  <div id="layout" class="layout">
    <div class="header-info">
      <div class="top-left">
        <div>
          <img src="./logo100.png" alt="" v-if="!imgLogo">
          <img :src="imgLogo" alt="" v-else>
          
          <!-- userform.companyLogo?userform.companyLogo:' -->
        </div>
        <div>
          {{headerTitle}}
        </div>
      </div>
      <div class="top-right">
        <!-- <div class="bg-white">
          <img :src="userImg" alt="">
        </div> -->
        <div class="bg-user" @click="isUser=!isUser" >
          <span class="user-name">{{userName}}</span>
          <span class="role-name">{{user.roleName}}</span>
          <span class="button_img" style="margin-left: 4px;overflow: hidden;">
            <img
            class="img-name"
              src="@/assets/images/icon_shang.png"
              style="transition: all 0.3s;"
              :style="{transform: `rotate(${isUser ? '-180deg' : 0})`}"
            />
          </span>
          <div v-show="isUser">
            <div class="bar-console">
              <span @click="closeSwitch">编辑信息</span>
            </div>
          </div>
          
        </div>
        <div class="bg-white" @click="closeLogin">
          <img src="@/assets/images/-s-icon_gb_.png" alt />
        </div>
      </div>
    </div>
    <el-dialog
      class="edit-dialog"
      title="编辑信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="570px"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="userform" label-width="80px">
        <el-form-item label="公司简称" class="name-input">
          <el-input oninput="this.value=this.value.replace(/\s+/g,'')" :disabled="user.roleName==='创建人'?false:true" v-model="userform.companyPcName" size="medium" maxlength="20"></el-input>
          <!-- <span style="float: right;color: #0981FF;">管理后台</span> -->
        </el-form-item>
        <el-form-item label="公司logo" v-if="user.roleName==='总监'||user.roleName==='子账号'?false:true">
          <!-- <img v-if="userform.companyLogo" :src="userform.companyLogo" alt="">
          <el-upload
            v-else
            :action="uploadUrl"
            :show-file-list="false"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            class="avatar-uploader"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload> -->
          <ElImgUpload
              :exist-image="userform.companyLogo"
              @handleDelete="handleRemove"
              @handleChange="handleAvatarSuccess"
          />
          <div></div>
        </el-form-item>
        <el-form-item label="登录账号" class="userAcc">
          <el-input oninput="this.value=this.value.replace(/\s+/g,'')" v-model="userform.userAcc"  size="medium" placeholder="输入登录账号（6-16位字母数字）"></el-input>
          <span  style="margin-left:10px;color:#FF687B;font-size:14px">提示:账号仅可修改一次</span>
        </el-form-item>
        <el-form-item label="登录密码" class="userPwd">
          <el-input oninput="this.value=this.value.replace(/\s+/g,'')" type="password" :disabled="!isReset" v-model="userPwd" size="medium" placeholder="输入登录密码（6-16位字母数字）"></el-input>
          <div style="float: right;"><el-button size="medium" type="warning" v-show="restVisible" @click="resetPwd(true)">重置密码</el-button></div>
          <div style="float: right;"><el-button size="medium" type="warning" v-show="!restVisible" @click="resetPwd(false)">取消重置</el-button></div>
        </el-form-item>
        <el-form-item label="确认密码"  v-if="isReset">
          <el-input oninput="this.value=this.value.replace(/\s+/g,'')" type="password" v-model="userPwdAgin" size="medium" placeholder="输入登录密码（6-16位字母数字）"></el-input>
        </el-form-item>
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="handleClose">取消</el-button>
        <el-button type="primary" :disabled="isSuccess" @click.native="handleSuccess">确定</el-button>
      </span>
    </el-dialog>
    <el-container style="height: calc(100vh - 50px);">
      <Aside />

      <el-container>
        <el-header>
          <!--页面标签栏-->
          <Breadcrumb />
        </el-header>

        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import ElImgUpload from '../components/global/components/elements/upload-element.vue'
import { Aside, Breadcrumb } from "./components";
import environments from '@/config/url'
import _api from "@/utils/request";


const uploadUrl = environments[process.env.VUE_APP_BASE_URL].uploadBaseUrl
export default {
  name: "Layout",
  components: { Aside, Breadcrumb,ElImgUpload },
  data() {
    return {
      userPwd:'',
      isSuccess:true,
      userPwdAgin:'',
      uploadUrl,
      imageUrl:'',
      userImg:'',
      isUser: false,
      headerTitle: "繁星回收后台管理系统",
      userName: "",
      restVisible:true,
      user: {},
      dialogVisible: false,
      userform: {
        companyPcName:'',
        companyLogo:'',
      },
      imgLogo:'',
      isReset: false
    };
  },
  created(){
    this.userform.companyLogo = localStorage.getItem('imgLogo')
    this.imgLogo = JSON.parse(localStorage.getItem('user')).companyLogo
    this.userImg=localStorage.getItem('userImg')
    this.userName=localStorage.getItem('userName')
    this.user=JSON.parse(localStorage.getItem('user'))
    this.headerTitle = '门店后台-' + this.user.companyPcName
    console.log(this.imgLogo);
    console.log(this.userform.companyLogo,'this.userform.companyLogo')
    document.body.addEventListener('click',(e)=>{
      if(e.target.className == 'bg-user'||e.target.className == 'role-name'||e.target.className == 'user-name' ||e.target.className == 'button_img'||e.target.className =='img-name'){
        this.isUser = true
      }else{
        this.isUser = false
      }
    })
  },
  watch:{
    'userform.companyPcName':{
      deep:true,
      handler:function(newV,oldV){
        console.log(newV,oldV)
        if(newV!=oldV&&this.restVisible){
          this.isSuccess = false
        }
      }
    },
    'userform.userAcc':{
      deep:true,
      handler:function(newV,oldV){
        console.log(newV,oldV)
        if(newV!=oldV&&this.restVisible){
          this.isSuccess = false
        }
      }
    },
    'userform.companyLogo':{
      deep:true,
      handler:function(newV,oldV){
        console.log(newV,oldV)
        if(newV!=oldV&&this.restVisible){
          this.isSuccess = false
        }
      }
    },
    dialogVisible(newVal){
      this.isSuccess = true
      if(newVal){
        this.isReset = false
        this.restVisible = true
        // this.isSuccess = false
      }else{
        this.isReset = true
        // this.isSuccess = false
        this.restVisible = false
      }
    },
    userPwdAgin(newVal){
      console.log('userPwdAgin',newVal)
      if(newVal==''||newVal!=this.userPwd){
        this.isSuccess = true
      }else{
        this.isSuccess = false
      }
    },
    userPwd(newVal){
      console.log('userPwd',newVal)
      if(newVal==''||newVal!=this.userPwdAgin){
        this.isSuccess = true
      }else{
        this.isSuccess = false
      }
    }
  },
  methods: {
    closeLogin() {
      this.$confirm('你是否要退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出登录成功!'
          })
           _api.logout({token:localStorage.getItem('token')}).then(res => {
            if(res.code === 1){
              localStorage.clear()
              this.$router.push("/login")
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    // 编辑回显
    closeSwitch() {
      this.userform = {
        companyPcName: this.user.companyPcName,
        companyLogo: this.user.companyLogo,
        userAcc: this.user.userAcc,
      }
      this.isSuccess = true
      this.userPwd =  '******',
      // this.userPwdAgin = '******',
      this.dialogVisible = true
      this.isUser = true
    },
    handleDialogClosed(){
      this.dialogVisible = false
    },
    handleAvatarSuccess (res) {
			console.log(res,'上传图片')
      this.userform.companyLogo = res
      console.log(this.userform.companyLogo)
		},
    handleRemove(){
      this.userform.companyLogo = ''
    },
    // 重置密码
    resetPwd(val) {
      this.restVisible = !this.restVisible
      if(val){
        this.isReset = true
        this.isSuccess = true
        this.userPwd = ''
        this.userPwdAgin = ''
      }else{
        this.isReset = false
        this.isSuccess = false
        this.userPwd = '******'
      }
    },
    //取消
    handleClose(){
      this.userPwdAgin = ''
      this.dialogVisible = false
    },
    handleSuccess(){
      console.log(this.userform);
      let params = {
        companyPcName: this.userform.companyPcName,
        companyLogo: this.userform.companyLogo,
        userAcc: this.userform.userAcc,
        userPwd:this.userPwd == '******'?'':this.userPwd
      }
      _api.updateOwnInfo(params).then(res => {
        console.log(res);
        if(res.code==1){
          localStorage.setItem("imgLogo", this.userform.companyLogo);
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.$router.push("/login")
        }
      })
    }
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.layout {
  aside,
  main {
    /*滚动条样式设置*/
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.4em;
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块*/
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 0.5em;
      -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
    }
    /*滑块轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 0.5em;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    }
  }
  .el-header {
    width: 100%;
    font-size: 12px;
    background-color: #f5f6fa;
    color: #333;
    //line-height: 60px;
    height: auto !important;
    box-shadow: 0px 1px 3px 0px rgba(208, 208, 208, 0.8);
  }

  .el-aside {
    color: #333;
  }

  .header-info {
    height: 50px;
    background: #0981ff;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top-left {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      margin-left: 23px;
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      font-family: MF LangQian (Noncommercial);
      font-weight: 400;
      color: #ffffff;
      // margin-left: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        // border-radius:18px;
        max-width: 120px;
        height: 36px;
        margin:15px 5px 0 0;
      }
    }
    .top-right {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      margin-right: 20px;
      .bg-white {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          border-radius: 50%;
          width: 70%;
          object-fit: contain;
        }
      }
      .bg-user {
        cursor: pointer;
        display: flex;
        align-items: center;
        // width: 63px;
        height: 20px;
        font-size: 14px;
        font-family: FZLanTingHei-M-GBK;
        font-weight: 400;
        color: #ffffff;
        margin: 0 20px 0 10px;
        
        .bar-console {
          z-index: 9999;
          position: absolute;
          right: 60px;
          top: 50px;
          width: 100px;
          height: 60px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 10px 0px rgba(92, 92, 92, 0.15);
          opacity: 0.9;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
           span {
            cursor: pointer;
            width: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            &:hover {
              background-color: rgba(#d4d9f8, 0.5);
            }
          }
        }
        .button_img {
          display: flex;
          align-items: center;
          width: 12px;
          height: 15px;
          border-radius: 3px;
          cursor: pointer;
          > img {
            vertical-align: middle;
          }
        }
        .user-name{
          font-size: 14px;
        }
        .role-name{
          margin-left: 9px;
          font-size: 12px;
          display: inline-block;
          line-height: 15px;
          background: #FFAF29;
          padding: 1px 4px;
          border-radius: 9px 9px 9px 0px;
        }
      }

    }
  }
  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .name-input{
    /deep/.el-input{
      // width: 365px;
    }
  }
  .userAcc{
    /deep/.el-input{
      width: 290px;
    }
    /deep/.el-button{
      padding: 10px 10px;
    }
  }
  .userPwd{
    /deep/.el-input{
      width: 345px;
    }
    /deep/.el-button{
      padding: 10px 10px;
    }
  }
}
</style>
